module.exports = __webpack_public_path__ + "images/mgb054e29dc09d2c9399767e45d2e3b281.png";